import { render, staticRenderFns } from "./on-service-edit-terminal.vue?vue&type=template&id=6298628c"
import script from "./on-service-edit-terminal.vue?vue&type=script&lang=js"
export * from "./on-service-edit-terminal.vue?vue&type=script&lang=js"
import style0 from "./on-service-edit-terminal.vue?vue&type=style&index=0&id=6298628c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports